// src/redux/reducers/rootReducer.js
import { combineReducers } from "redux";
import authReducer from "./authReducer";
import locationReducer from "./locationReducer";
import canteenReducer from "./canteenReducer";
import surveyReducer from "./surveyReducer";
import kitchenReducer from "./kitchenReducer";
import kitchenDiningReducer from "./kitchenDiningReducer"; 
import kitchenSurveyReducer from "./kitchenSurveyReducer";
import KitchenDiningSurveyDetail from "./kitchenDiningSurveyReducer"; // Add this



const rootReducer = combineReducers({
   auth: authReducer,        // Authentication state
  location: locationReducer, // District → Municipality → Ward → Canteen
  canteen: canteenReducer,
  survey: surveyReducer,
   kitchen: kitchenReducer,
    kitchenDining: kitchenDiningReducer,
     kitchenSurvey: kitchenSurveyReducer,
      kitchenDiningSurvey: KitchenDiningSurveyDetail,
});

export default rootReducer;
